


import { NestedValueExtractor } from "../../general_components/content_management/list_view/listView";

import { TRUCK_ADD_CONF } from "./truckAddConf";
import { TRUCK_PAGE_OBJECT } from "./truckPageConf";
import { API_ROOT } from "../../supplementary_components/requests";



const ROOT_PATH = "/trucks/"

const currentDriversGenerator = (data) =>{
    let result = NestedValueExtractor(data, [["driver1", "firstName"], " / ", ["driver2", "firstName"] ])
    if (result.slice(result.length-3, result.length) === '/ -'){
        result = result.slice(0, result.length-3) + NestedValueExtractor(data, [["driver1", "lastName"]])
    }else if (result.slice(0, 3) === "- /"){
        result = result.slice(3, result.length) + ' ' + NestedValueExtractor(data, [["driver2", "lastName"]])
    }

    return result;
}

export const TRUCK_LISTING_CONF = {
    getRequestLink: API_ROOT+"trucks",
    columnProportions: "7.5% 13.3% 10.66% 18% 18% 18.5% 1fr",
    dataTitle: "Truck",
    dataTitlePlural:"Trucks",
    addButton:true,
    addConf: TRUCK_ADD_CONF,
    minAccessToItemPage: { key: 'TRUCKS', level: 'VIEW' },
    filtration:{
        // multipleFiltrationAllowed: true,
        filtrationLinkRoot: "trucks/filtration",
        searchByFieldNames:[
            {
                valueLocation: "truckNumber",
                categoryLbl: "By Truck Number",
            },
            {
                filtrationLbl: "status:",
                searchKey: "byStatus",
                hint: "Status",
                conditionalCheck: (term, data)=>{
                    if(term.includes(",")){
                        return term.split(",").map(status => status.trim()).includes(data.truckStatus.toLowerCase());
                    }
                    return term === data.truckStatus.toLowerCase(); // === (term === "active")
                },
                customSuggestions:[
                    "Active",
                    "Inactive",
                    "Sold",
                    "Terminated"
                ]
            },
            {
                valueLocation: 'truckType',
                filtrationLbl: "type:",
                searchKey: "byType",
                hint: "Type",
                customSuggestions:[
                    "Company",
                    "Owner",
                    "Lease"
                ]
            },
            {
                // valueLocation: ['driver1', 'driver2'],
                filtrationLbl: "driver(s):",
                searchKey: "byDriver",
                hint: "Solo, Team, ...",
                conditionalCheck: (term, data)=>{
                    if(term === "no drivers"){
                        return !data.driver1 && !data.driver2;
                    }else if(term === "solo"){
                        return (data.driver1 !== null && data.driver2 === null) || (data.driver1 === null && data.driver2 !== null);
                    }else if(term === "team"){
                        return data.driver1 !== null && data.driver2 !== null;
                    }
                    return false;
                },
                customSuggestions:[
                    "No Drivers",
                    "Solo",
                    "Team"
                ]
            },
            {
                filtrationLbl: "dispatcher:",
                searchKey: "byDispatcher",
                hint: "Dispatcher",
                conditionalCheck: (term, data)=>{
                    if(term === "no dispatch"){
                        return !data.dispatcher && !data.dispatchTeam;
                    }else if(data.dispatcher){
                        return (data.dispatcher['firstName'] + " " + data.dispatcher['lastName']).toLocaleLowerCase().includes(term);
                    }else if(data.dispatchTeam){
                        return (data.dispatchTeam['teamName']).toLocaleLowerCase().includes(term);
                    }
                    return false;
                },
                customSuggestions:[
                    "No Dispatch"
                ],
                acceptSuggestionAsTerm: true,
            },
        ]
    },
    pageConf: new TRUCK_PAGE_OBJECT(),
    category: 'trucks',
    columns :[
        {
            label: "Truck",
            columnName: "truckNumber",
            sortable: true,
            identifierColumnName: "id",
            clickable: true,
            path: ROOT_PATH,
        },
        {
            label: "Status",
            columnName: "truckStatus",
            sortable: true,
            clickable: false,
            path: null,
            conditionalFormatting: (value)=>{
                if(value === "Active")return null;
                if(value === "Sold")return `& > * {color:white;
                        font-weight:600;
                        background:var(--inProgressBlue);
                        padding: 0.1rem 0.9rem;
                        border-radius:1rem;}`;
                return `& > * {color:white;
                        font-weight:600;
                        background:var(--alert-color);
                        padding: 0.1rem 0.9rem;
                        border-radius:1rem;}`

            },
            valueInterpreter: (value)=>{
                // if(value)return "Active";
                return value;
            },
            alignment:"center",
        },
        {
            label: "Type",
            columnName: "truckType",
            sortable: true,
        },
        {
            label: "Driver(s)",
            valueGenerator: currentDriversGenerator
        },
        {
            label: "Dispatcher",
            valueGenerator: (data)=>{
                if(data.dispatcher){
                    return `${data.dispatcher['firstName']} ${data.dispatcher['lastName']}`;
                }else if(data.dispatchTeam){
                    return `Team: ${data.dispatchTeam['teamName']}`;
                }
                return "-";
            },
            sortable: true,
        },
        {
            label: "Vin",
            columnName: "vin",
        },
        
        {
            label: "Current Trailer",
            valueGenerator: (data)=>{
                return NestedValueExtractor(data, [["currentTrailer", "trailerNumber"]]);
            },
            alignment: "right",
        }
    ]
}
